import { useLazyQuery } from '@apollo/client';
import AlgoliaPagination from '@website/components/search/algolia/AlgoliaPagination';
import { AlgoliaSearchClient } from '@website/components/trips/search/AlgoliaSearchClient';
import TextSearch from '@website/components/trips/search/filters/TextSearch';
import { DownloadReviewsCsvDocument } from '@website/types/graphqlOperations';
import { useCallback } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Configure, connectHits, InstantSearch } from 'react-instantsearch-dom';
import DataTable from '../DataTable';
import FilterByTrips from '../TripsDropdownFilter';
import { adminReviewsColumns, ReviewsAlgoliaHit } from './adminReviews';

function SearchItemResults({ hits }: { hits: ReviewsAlgoliaHit[] }) {
  const [download, { loading }] = useLazyQuery(DownloadReviewsCsvDocument, {
    fetchPolicy: 'network-only',
  });

  const downloadCsv = useCallback(async () => {
    const { data } = await download();
    const { downloadUrl } = data.exportReviewsToCSV;
    // Create a link and click it to download the file
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'reviews.csv';
    document.body.appendChild(link);
    link.click();
  }, [download]);

  return (
    <Row>
      <Col xs={12} className="py-2 align-items-end">
        <Button
          disabled={loading}
          className="align-self-end"
          onClick={downloadCsv}
        >
          {loading ? <>Downloading...</> : <> Download CSV</>}
        </Button>
      </Col>
      <Col xs={12}>
        <DataTable data={hits} columns={adminReviewsColumns} />
      </Col>
    </Row>
  );
}

export const SearchItemResultsConnected = connectHits(SearchItemResults as any);

export default function AdminReviewsTable() {
  return (
    <Container fluid className="pt-3">
      <InstantSearch searchClient={AlgoliaSearchClient} indexName="reviews">
        <Row>
          <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
            <TextSearch />
          </Col>
          <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
            <FilterByTrips
              operator="or"
              attribute="guest.booking.group.trip.id"
              limit={100}
            />
          </Col>
        </Row>
        <Configure hitsPerPage={100} />
        <SearchItemResultsConnected />
        <AlgoliaPagination />
      </InstantSearch>
    </Container>
  );
}
